module.exports = __webpack_public_path__ + "static/media/match_success.c48f426f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/connections/match_success.svg
// module id = 883
// module chunks = 0